// Zamanaşımı sonuç gösterimi ve raporu için ORTAK tarih/süre formatlayıcıları.
// Tek kaynak — ekrandaki tablo ile rapor çıktısı birebir aynı biçimi kullansın.

import { tarihFarki } from './tarihHesaplamalari';
import { farkMetni } from './asamalar';

// Tarihi yerel gün başına (00:00) çeker; saat bileşeni gün/ay/yıl farkını kaydırmasın.
const gunBasi = (t) => {
  const d = new Date(t);
  d.setHours(0, 0, 0, 0);
  return d;
};

/** Tarih → "01.02.2026" (kısa, tabular). */
export const formatKisa = (t) =>
  new Date(t).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });

/** Tarih → "1 Şubat 2026" (uzun, başlıklar için). */
export const formatUzun = (t) =>
  new Date(t).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });

/** Süre (period) {year,month,day} → "8 yıl" / "5 yıl 4 ay". */
export function formatSure(sure) {
  if (!sure) return '0 gün';
  const p = [];
  if (sure.year > 0) p.push(`${sure.year} yıl`);
  if (sure.month > 0) p.push(`${sure.month} ay`);
  if (sure.day > 0) p.push(`${sure.day} gün`);
  return p.join(' ') || '0 gün';
}

/**
 * İki tarih arası süreyi ekran ve raporun ORTAK kullandığı biçimde verir.
 * Süre tarih bazlı yıl/ay/gün'dür (TCK 66/6 — gün bölmesi değil takvim farkı).
 * Ham gün yalnız yıl/ay içeren ifadelerde parantezde gösterilir; "9 gün (9 gün)" tekrarını önler.
 * @param {Date|number|string} bas başlangıç
 * @param {Date|number|string} bit bitiş
 * @param {number} [gunSayisi] parantezde gösterilecek KANONIK gün (örn. kalanGun,
 *   durmaGunSayisi). Verilmezse takvim farkının gün sayısı kullanılır.
 * @returns {{sure:string, gun:string, cokParcali:boolean, ifade:string}}
 *   sure "8 yıl" · gun "2922 gün" · ifade "8 yıl (2922 gün)" (yalnız gün varsa "9 gün")
 */
export function sureIfade(bas, bit, gunSayisi) {
  const f = tarihFarki(gunBasi(bas), gunBasi(bit));
  const g = gunSayisi != null ? gunSayisi : f.gunSayisi;
  const cokParcali = f.yil > 0 || f.ay > 0;
  const sure = farkMetni(f);
  return { sure, gun: `${g} gün`, cokParcali, ifade: cokParcali ? `${sure} (${g} gün)` : sure };
}

/**
 * Kalan zamanaşımı süresi — `sureIfade`'nin sonuc/timelineModel için sarmalayıcısı.
 * `m` = hesaplaZamanAsimi sonucu veya timelineModel (bugun/effective/kalanGun/zamanAsimiDoldu).
 * @returns {{doldu:boolean, sure:string, gun:string, cokParcali:boolean, ifade:string}}
 */
export function kalanSure(m) {
  if (!m || m.zamanAsimiDoldu) return { doldu: true, sure: '', gun: '', cokParcali: false, ifade: '' };
  return { doldu: false, ...sureIfade(m.bugun, m.effective, m.kalanGun) };
}

/**
 * Toplam durma süresi gösterimi. Tek durma aralığı varsa gerçek takvim yıl/ay/gün (+gün);
 * birden çok AYRIK aralıkta birleşik takvim karşılığı belirsiz olduğundan salt gün döner.
 * @param {Array<{bas:(Date|number|string), bit:(Date|number|string)}>} durmalar
 * @param {number} toplamGun durmaların net gün toplamı (kanonik)
 */
export function durmaToplamIfade(durmalar, toplamGun) {
  if (!toplamGun || toplamGun <= 0) return '';
  if (durmalar && durmalar.length === 1) return sureIfade(durmalar[0].bas, durmalar[0].bit, toplamGun).ifade;
  return `${toplamGun} gün`;
}
